import { create } from 'zustand'

export const useCollectionStore = create<{
  productCount: number
  setProductCount: (count: number) => void
  filter: {
    [key: string]: string[] | string | undefined
  }
  setFilter: (filter: { [key: string]: string[] | string | undefined }) => void
}>((set) => ({
  productCount: 0,
  setProductCount: (count) => set({ productCount: count }),
  filter: {},
  setFilter: (filter) => set({ filter: { ...filter } }),
}))
